import { Package, Shield, FileText, BarChart3, Heart, Sparkles } from "lucide-react";
import { useReveal } from "../../lib/reveal";

const cards = [
  {
    icon: Sparkles,
    title: "Curadoria temática",
    body: "Cada kit é desenhado em diálogo com o conteúdo do seu curso — itens que reforçam a mensagem, não apenas a marca.",
    span: "md:col-span-2 md:row-span-1",
    tone: "light",
  },
  {
    icon: Package,
    title: "Montagem artesanal",
    body: "Embalagens estudadas para sobreviver à logística brasileira sem perder a estética premium.",
    span: "md:col-span-1 md:row-span-2",
    tone: "dark",
  },
  {
    icon: Shield,
    title: "Proteção em trânsito",
    body: "Embalagem reforçada, desenhada para suportar o transporte até chegar em perfeitas condições ao destino.",
    span: "md:col-span-1",
    tone: "light",
  },
  {
    icon: FileText,
    title: "Documentação legal",
    body: "Cartas, etiquetas e descritivos de conteúdo conforme legislação vigente. Tudo pronto, sem dor de cabeça.",
    span: "md:col-span-1",
    tone: "light",
  },
  {
    icon: BarChart3,
    title: "Relatórios de envio",
    body: "Painel completo: o que saiu, para quem, quando chegou. Visibilidade do começo ao fim.",
    span: "md:col-span-2",
    tone: "image",
  },
  {
    icon: Heart,
    title: "Follow-up de satisfação",
    body: "Coletamos feedback dos seus alunos, sempre visando aperfeiçoar as próximas experiências.",
    span: "md:col-span-1",
    tone: "light",
  },
];

function Card({ c }) {
  const Icon = c.icon;
  if (c.tone === "image") {
    return (
      <div
        data-testid={`diferencial-card-${c.title}`}
        className={`relative overflow-hidden min-h-[280px] ${c.span}`}
      >
        <img
          src="https://static.prod-images.emergentagent.com/jobs/6a000596-9294-4f6e-b050-33055cbb9274/images/adba56ab41fe6b0dd3f8ceba5e829702d82a16b657aa74238e3f23302b3e5fd0.png"
          alt={c.title}
          className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B2E24]/85 via-[#0B2E24]/40 to-transparent" />
        <div className="relative p-8 md:p-10 h-full flex flex-col justify-end text-[#FAFAFA]">
          <Icon size={22} strokeWidth={1.5} className="text-[#C5A059]" />
          <h3 className="font-serif text-2xl md:text-3xl mt-4">{c.title}</h3>
          <p className="mt-3 text-sm md:text-base font-light text-[#FAFAFA]/85 max-w-md">{c.body}</p>
        </div>
      </div>
    );
  }

  const isDark = c.tone === "dark";
  return (
    <div
      data-testid={`diferencial-card-${c.title}`}
      className={`p-8 md:p-10 transition-all duration-500 hover:-translate-y-1 ${c.span}`}
      style={{
        backgroundColor: isDark ? "#0B2E24" : "#FFFFFF",
        color: isDark ? "#FAFAFA" : "#1C1C1C",
        border: isDark ? "none" : "1px solid rgba(28,28,28,0.08)",
      }}
    >
      <Icon size={22} strokeWidth={1.5} className={isDark ? "text-[#C5A059]" : "text-[#0B2E24]"} />
      <h3 className="font-serif text-2xl md:text-3xl mt-5 leading-tight">{c.title}</h3>
      <div className="hairline-gold my-5" />
      <p className={`text-sm md:text-base font-light leading-relaxed ${isDark ? "text-[#FAFAFA]/85" : "text-[#556052]"}`}>
        {c.body}
      </p>
    </div>
  );
}

export default function Diferenciais() {
  const { ref, visible } = useReveal();
  return (
    <section
      id="diferenciais"
      ref={ref}
      data-testid="diferenciais-section"
      className="py-24 md:py-32"
      style={{ backgroundColor: "#FAFAFA" }}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className={`max-w-3xl mb-16 md:mb-20 reveal ${visible ? "in" : ""}`}>
          <p className="overline">A arte de encantar</p>
          <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-6xl tracking-tight text-[#1C1C1C] mt-6 leading-[1.05]">
            Tudo o que está entre <em className="italic text-[#556052]">você e o</em> seu aluno —
            cuidado por nós.
          </h2>
        </div>

        <div className={`grid grid-cols-1 md:grid-cols-3 grid-flow-row-dense gap-6 md:gap-8 reveal ${visible ? "in" : ""}`}>
          {cards.map((c) => (
            <Card key={c.title} c={c} />
          ))}
        </div>
      </div>
    </section>
  );
}
